module.exports = __webpack_public_path__ + "static/img/DeluxeFamilyRoom2.7b60981e.jpg";